import { useQuery } from "@tanstack/react-query";
import apiClient from "../client";

/** Scr.Enums.MembershipPlatformType. */
export const MembershipPlatformType = {
  Internal: 1,
  External: 2,
} as const;

export interface MembershipTierPlatformDto {
  id: string;
  name: string;
  type: number;
  /** #RRGGBB. */
  badgeColour: string;
  /** Null shows the first letter of the platform's name. */
  badgeLetters: string | null;
  /** What the platform asks a customer for, e.g. "The email on your Patreon account". Null for ours. */
  accountPrompt: string | null;
}

export interface MembershipTierDto {
  id: string;
  name: string;
  description: string;
  monthlyPriceUsd: number | null;
  yearlyPriceUsd: number | null;
  priceNote: string | null;
  tradingStrategyIds: string[];
  platform: MembershipTierPlatformDto;
}

interface ListMembershipTiersResponse {
  items: MembershipTierDto[];
}

/** Every live tier, ours and other platforms'. */
export function useMembershipTiers() {
  return useQuery<MembershipTierDto[]>({
    queryKey: ["membership-tiers"],
    queryFn: async () => {
      const res = await apiClient.get<ListMembershipTiersResponse>("/membership-tiers");
      return res.data.items;
    },
  });
}

/** A tier on another platform: one a customer can tell us they hold. */
export const isExternalTier = (tier: MembershipTierDto) =>
  tier.platform.type === MembershipPlatformType.External;
